import React, { useState } from "react";
import { ProgressBar } from "primereact/progressbar";
import { Avatar } from "primereact/avatar";
import { Calendar } from "primereact/calendar";
import Spinner from "../../components/spinner";
import { Dropdown } from "primereact/dropdown";

const TicketsStatsComponent = ({ dashboardData, loading }) => {
  const [date, setDate] = useState(new Date());
  const [selectedMachine, setSelectedMachine] = useState(null);

  const kioskData = dashboardData?.kioskTicketStats?.[0] || {};

  const machines = [
    { label: "KIOSK 1", value: "KIOSK 1" },
    { label: "KIOSK 2", value: "KIOSK 2" },
    { label: "KIOSK 3", value: "KIOSK 3" },
    { label: "KIOSK 4", value: "KIOSK 4" },
  ];

  return (
    <>
      <div className="d-flex justify-content-between align-items-center my-2">
        <h2 className="text-xl font-bold mb-0">{kioskData.kioskId || "--"}</h2>
        <div className="filters">
          <Dropdown
            value={selectedMachine}
            options={machines}
            onChange={(e) => setSelectedMachine(e.value)}
            placeholder="Select Machine"
          />
          <Calendar value={date} onChange={(e) => setDate(e.value)} showIcon />
        </div>
      </div>

      <div className="p-fluid grid">
        <div className="field col-12 md:col-12 lg:col-4">
          <div className="card h-full flex flex-col">
            <h3 className="text-lg font-semibold mb-2">Today</h3>
            <span className="text-sm font-medium">Ticket Received</span>
            <div className="text-6xl font-bold mt-2 text-cyan-700">
              {kioskData.ticketsReceived || "--"}
            </div>
          </div>
        </div>

        <div className="field col-12 md:col-12 lg:col-4">
          <div className="card h-full flex flex-col">
            <h3 className="text-lg font-semibold mb-2 text-left">
              Tickets by Status
            </h3>
            <div className="mt-2">
              <span className="text-sm font-medium">Solved</span>
              <ProgressBar
                value={kioskData.ticketsSolvedPercentage || 0}
                className="mb-2 progress-bar"
              />
              <span className="text-sm font-medium">In Progress</span>
              <ProgressBar value={kioskData.ticketsInProgressPercentage || 0} />
            </div>
          </div>
        </div>

        <div className="field col-12 md:col-12 lg:col-4">
          <div className="card h-full flex flex-col">
            <h3 className="text-lg font-semibold mb-2">Top Ticket Solvers</h3>
            <div className="mt-2 overflow-y-auto" style={{ height: "110px" }}>
              {kioskData.topTicketSolvers?.length > 0 ? (
                kioskData.topTicketSolvers.map((solver, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center gap-2 mb-2"
                  >
                    <Avatar
                      icon="pi pi-user"
                      shape="circle"
                      className="bg-gray-200 border rounded-full useravatars"
                    />
                    <span className="font-medium">{solver.name}</span>
                    <span className="ml-auto font-semibold">
                      {solver.ticketsSolved}
                    </span>
                  </div>
                ))
              ) : (
                <p className="fw-bold">--</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TicketsStatsComponent;
